import React from 'react';

import { ScreenContent } from '@components/ScreenContent';
import { Typography } from '@components/Typography';

export { AcceptedOrderScreen } from './AcceptedOrder';
export { AcceptedOrdersScreen } from './AcceptedOrders';
export { MenuScreen } from './Menus';
export { NewOrdersScreen } from './NewOrders';
export { NewOrderScreen } from './NewOrder';
export { OrdersHistoryScreen } from './OrdersHistory';
export { OrderHistoryScreen } from './OrderHistory';

export { LoginScreen } from './LoginScreen';

export const TripsScreen = () => (
  <ScreenContent>
    <Typography>Trips Page</Typography>
  </ScreenContent>
);
